import React, { PropTypes } from 'react';
import { isEmpty } from 'ramda';
import { connect } from 'react-redux';
import { Dialog, FlatButton } from 'material-ui';
import { prop } from 'ramda';
import TCContactImport from '../../invite-contacts/tc-contact-import';

const ImportFromEmail = props => {
  const {
    updateMMPartnerProp,
  } = props;
  const MMPartnerReducer = isEmpty(props.MMPartnerReducer2) ? props.MMPartnerReducer : props.MMPartnerReducer2; // fallback to reducer
  return (
    <Dialog
      open={MMPartnerReducer.showEmailImportDialog}
      actions={[
        <FlatButton
          label="Cancel"
          primary
          labelStyle={{ fontWeight: '600' }}
          onTouchTap={() => updateMMPartnerProp({
            showEmailImportDialog: false,
            addPartnersMethod: '',
          })}
        />,
      ]}
      title="Import From Email"
      contentStyle={{ width: '512px' }}
      bodyStyle={{ paddingTop: '0' }}
    >
      <div style={{ marginTop: '15px' }}>
        <div style={{ marginBottom: '15px' }}>
          Select which email provider you would like to import your contacts from.
        </div>
        <TCContactImport
          afterSubmitContacts={(contacts) => {
            const pullEmail = contacts.map(contact => ({
              email: prop('__selectedMail__', contact),
            }));
            updateMMPartnerProp({
              showEmailImportDialog: false,
              showReview: true,
              addPartnersMethod: '',
              partnersToSendTo: MMPartnerReducer.partnersToSendTo.concat(pullEmail),
              showSelectMethod: false,
            });
          }}
        />
      </div>
    </Dialog>
  );
};

ImportFromEmail.propTypes = {
  updateMMPartnerProp: PropTypes.func,
  MMPartnerReducer: PropTypes.object,
  MMPartnerReducer2: PropTypes.object,
};


ImportFromEmail.defaultProps = {
  MMPartnerReducer2: {},
};

const mapStateToProps = ({ marketingMaterials }) => ({
  MMPartnerReducer: marketingMaterials.partnerReducer.toJS(),
});

export default connect(mapStateToProps)(ImportFromEmail);



// WEBPACK FOOTER //
// ./src/app/components/marketing-materials/send-to-partners/import-from-email.jsx